const style = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#0D1117",
  },
  loginBox: {
    width: "100%",
    maxWidth: "600px",
    padding: "0px 40px 40px 40px",
    backgroundColor: "rgba(22, 27, 34, 0.8)",
    border: "1px solid #30363D",
    borderRadius: "16px",
    backdropFilter: "blur(10px)",
    boxSizing: "border-box",
  },
  header: {
    textAlign: "center",
    marginBottom: "32px",
  },
  logo: {
    width: "300px",
    height: "auto",
    filter: "drop-shadow(0px 5px 25px rgba(0,200,220,0.2))",
    // marginBottom: "24px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    color: "#E6EDF3",
    margin: "0 0 8px 0",
  },
  subtitle: {
    fontSize: "16px",
    color: "#8B949E",
    margin: 0,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#8B949E",
    marginBottom: "8px",
  },
  input: {
    backgroundColor: "#0D1117",
    border: "1px solid #30363D",
    borderRadius: "8px",
    padding: "12px 16px",
    fontSize: "16px",
    color: "#E6EDF3",
    outline: "none",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  },
  forgotPassword: {
    fontSize: "14px",
    color: "#58A6FF",
    textDecoration: "none",
    textAlign: "right",
    transition: "color 0.2s ease",
  },
  loginButton: {
    backgroundColor: "#58A6FF",
    color: "#0D1117",
    border: "none",
    borderRadius: "8px",
    padding: "14px 20px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "16px",
    marginTop: "12px",
    transition: "opacity 0.2s ease",
  },
};

export default style;
